import { IUser } from "authentication/domain/IUser";
import UserSettings from "./UserSettings";

interface IProps {
  setClickOutsideActive: Function;
  currentUser: IUser;
}

const UserTooltip = (props: IProps) => {
  return (
    <>
      <div className="settings-tooltip">
        <UserSettings {...props} />
      </div>
    </>
  );
};

export default UserTooltip;
